module.exports = __webpack_public_path__ + "static/media/error_outline.7e15e217.svg";